export enum FormElement {
  AUTOCOMPLETE = "autocomplete",
  CHECKBOX = "checkbox",
  COPY = "copy",
  DATE_PICKER = "datePicker",
  IMAGE_UPLOADER_MULTIPLE = "imageUploaderMultiple",
  IMAGE_UPLOADER_SINGLE = "imageUploaderSingle",
  INPUT = "input",
  TEXTAREA = "textarea",
  TIME_PICKER = "timePicker",
  MARKETING_CHECKBOX = "marketingCheckbox",
  NUMBER = "number",
  PHONE = "phone",
  RADIO = "radio",
  SELECT = "select",
  SELECT_CITY = "selectCity",
  SELECT_MAKE = "selectMake",
  SELECT_MODEL = "selectModel",
  REDIRECT = "redirect",
  MULTIPLE_PERSON = "multiplePerson",
  ZIP_CODE = "zipCode",
}

export enum FormType {
  WELCOME = "welcome",
  AC = "ac",
  OC = "oc",
  OC_VEHICLE = "oc/vehicle",
  OC_PROPERTY = "oc/property",
  OC_PERSON = "oc/person",
}

export enum FormId {
  APPLICANT = "applicant",
  APPLICANT_DRIVER = "driver",
  APPLICANT_ADDITIONAL = "additional",
  DAMAGES_IMAGES_DESCRIPTION = "imagesDescription",
  DAMAGES_ADDITIONAL = "additional",
  INCIDENT_CIRCUMSTANCES = "circumstances",
  INCIDENT_DAMAGE = "damage",
  INCIDENT_DRIVER = "driver",
  INCIDENT_STATEMENTS = "statements",
  INCIDENT_OTHER_PERSONS = "otherPersons",
  INCIDENT_WITNESSES = "witnesses",
  OWNER_GENERAL_DATA = "ownerGeneralData",
  PERPETRATOR_GENERAL = "general",
  PERPETRATOR_DATA = "perpetrator",
  PERPETRATOR_OWNER = "owner",
  PERPETRATOR_COMPANY_DATA = "companyData",
  INTRODUCTORY_APPLICANT = "applicant",
  INTRODUCTORY_PERPETRATOR = "perpetrator",
  VEHICLE_OWNER_VEHICLE = "vehicle",
  VEHICLE_OWNER_OWNER = "owner",
  VEHICLE_OWNER_COMPANY_DATA = "ownerCompany",
  VEHICLE_OWNER_PERSON_DATA = "ownerPerson",
  VEHICLE_OWNER_CONTACT_PERSON_DATA = "contactPerson",
  OWNER_GENERAL = "general",
  OWNER_PERSON_DATA = "person",
  OWNER_COMPANY_DATA = "company",
  OWNER_CONTACT_PERSON_DATA = "contactPerson",
}
